var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.691,
    height: 64,
    viewBox: "0 0 57.691 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.691,
    height: 64,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.171,17.191C51.063,24.45,57.19,30.153,57.662,36.375c.471,6.175-4.713,12.868-10.653,18.147C41.117,59.848,34.424,63.807,27.637,64c-6.834.142-13.763-3.535-18.854-8.861a31.917,31.917,0,0,1-8.72-19.75A35.648,35.648,0,0,1,6.8,12.76C11.847,5.5,19.812-1,26.647.128c6.881,1.084,12.585,9.851,18.524,17.063",
    transform: "translate(0 0)",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M81.6,79.938l-3.657,3.657a1.223,1.223,0,0,1-1.724,0l-1.83-1.83a1.219,1.219,0,0,1,1.724-1.724l.969.969,2.795-2.795A1.219,1.219,0,1,1,81.6,79.938",
    transform: "translate(-42.445 -44.637)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.668,66.426A7.925,7.925,0,1,0,80.6,74.349a7.926,7.926,0,0,0-7.927-7.923m0,13.41a5.485,5.485,0,1,1,5.487-5.487,5.487,5.487,0,0,1-5.487,5.487",
    transform: "translate(-37.12 -38.084)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.948,72.146a5.485,5.485,0,1,0,5.487,5.483,5.486,5.486,0,0,0-5.487-5.483m3.605,4.518L75.9,80.321a1.223,1.223,0,0,1-1.724,0l-1.83-1.83a1.219,1.219,0,0,1,1.724-1.724l.969.969,2.795-2.795a1.219,1.219,0,0,1,1.724,1.724",
    transform: "translate(-40.4 -41.364)",
    fill: "#02e2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.757,66.7H56.481a1.219,1.219,0,1,1,0,2.438H34.538a1.218,1.218,0,0,1-1.219-1.219v-31.7A1.219,1.219,0,0,1,34.538,35H50.386a1.218,1.218,0,0,1,.861.358l6.1,6.095a1.22,1.22,0,0,1,.358.862v3.048a1.219,1.219,0,0,1-2.438,0V42.819l-5.381-5.381H35.757Z",
    transform: "translate(-19.103 -20.067)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.967,53.153h3.657a1.219,1.219,0,1,0,0-2.438H45.967a1.219,1.219,0,0,0,0,2.438",
    transform: "translate(-25.656 -29.077)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.967,67.438h6.7a1.219,1.219,0,0,0,0-2.438h-6.7a1.219,1.219,0,0,0,0,2.438",
    transform: "translate(-25.656 -37.267)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.967,81.724h4.267a1.219,1.219,0,1,0,0-2.438H45.967a1.219,1.219,0,1,0,0,2.438",
    transform: "translate(-25.656 -45.457)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.967,96.01h5.486a1.219,1.219,0,0,0,0-2.438H45.967a1.219,1.219,0,0,0,0,2.438",
    transform: "translate(-25.656 -53.648)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.543,35.358a1.219,1.219,0,0,0-2.081.862v6.1a1.219,1.219,0,0,0,1.219,1.219h6.1a1.219,1.219,0,0,0,.862-2.081ZM72.9,41.1h1.933L72.9,39.163Z",
    transform: "translate(-40.398 -20.067)",
    fill: "#2b528e",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignments);
export default __webpack_public_path__ + "static/media/assignments.fa2f10c97ae002fbbf757889e56856a3.svg";
export { ForwardRef as ReactComponent };